/** 视频翻译主路径顶栏步骤，与 video/upload 对齐；步骤下不展示 description。 */
export const VIDEO_PIPELINE_STEP_KEYS = [
  'createProject',
  'uploadVideo',
  'subtitleProcessing',
  'aiTranslation',
  'completeOrAssign',
  'completeOutput',
] as const

export const VIDEO_PIPELINE_STEP = {
  CREATE_PROJECT: 0,
  UPLOAD_VIDEO: 1,
  SUBTITLE_PROCESSING: 2,
  AI_TRANSLATION: 3,
  COMPLETE_OR_ASSIGN: 4,
  COMPLETE_OUTPUT: 5,
} as const
